/**
 * RuleCMS-owned name aliases. A name that has ever been persisted is never
 * deleted — only aliased here to the current Lucide kebab name.
 *
 * Seeded from Lucide's own rename shims (shape-first convention). Extend on
 * every upstream lucide-static sync; the sync job should fail when an upstream
 * icon disappears without an alias.
 */
export const ICON_NAME_ALIASES: Record<string, string> = {
  'alert-circle': 'circle-alert',
  'alert-octagon': 'octagon-alert',
  'alert-triangle': 'triangle-alert',
  'arrow-down-circle': 'circle-arrow-down',
  'arrow-left-circle': 'circle-arrow-left',
  'arrow-right-circle': 'circle-arrow-right',
  'arrow-up-circle': 'circle-arrow-up',
  'check-circle': 'circle-check',
  'check-circle-2': 'circle-check-big',
  'divide-circle': 'circle-divide',
  // Renamed twice upstream: help-circle -> circle-help -> circle-question-mark.
  // Both historical spellings have to land on the current name.
  'help-circle': 'circle-question-mark',
  'circle-help': 'circle-question-mark',
  'minus-circle': 'circle-minus',
  'pause-circle': 'circle-pause',
  'plus-circle': 'circle-plus',
  'stop-circle': 'circle-stop',
  'x-circle': 'circle-x',
  'x-octagon': 'octagon-x',
  'x-square': 'square-x',
};
